import type { Person } from '../lib/queries'

/**
 * **Die `<option>`s einer Abnehmer-Auswahl – Welt zuerst, dann die übrigen** (16.09.2026,
 * [E-355](../../../../docs/ENTSCHEIDUNGEN.md#e-355)).
 *
 * Ein Fragment ohne `<select>`, weil die Aufrufer verschiedene Selects haben (das
 * `AufklappSelect` im Aufgabendetail, ein nacktes `<select>` im Vorhaben-Panel und im
 * Anlege-Dialog) und jeder seinen eigenen Leereintrag davor stellt. Gemeinsam ist nur die
 * Liste – und dass sie überall gleich gruppiert ist, ist der Zweck dieses Bausteins.
 *
 * Ohne zweite Gruppe gibt es auch keine `<optgroup>`: bei einer einzigen Welt sähe eine
 * Überschrift „in dieser Welt" aus, als gäbe es noch andere.
 */
export function PersonenOptionen({
  inWelt,
  weitere,
}: {
  inWelt: readonly Person[]
  weitere: readonly Person[]
}) {
  if (weitere.length === 0) {
    return (
      <>
        {inWelt.map((p) => (
          <option key={p.id} value={p.id}>
            {p.displayName}
          </option>
        ))}
      </>
    )
  }
  return (
    <>
      <optgroup label="In dieser Welt">
        {inWelt.map((p) => (
          <option key={p.id} value={p.id}>
            {p.displayName}
          </option>
        ))}
      </optgroup>
      <optgroup label="Weitere – sehen nur, was auf sie wartet">
        {weitere.map((p) => (
          <option key={p.id} value={p.id}>
            {p.displayName}
            {p.canLogin ? '' : ' (per Mail)'}
          </option>
        ))}
      </optgroup>
    </>
  )
}
